import { useAccount, useReadContract } from 'wagmi';
import { getCampaignByWeek, getClaimerContractAddress, MAX_WEEK_ON_CLAIMER } from './utils';
import { ClaimedStatusByCampaign } from './types';
import { useMemo } from 'react';
// const claimerAbi = require('./claimer-abi');

type UseClaimedStatusByCampaignReturn = {
  claimedByCampaign: ClaimedStatusByCampaign;
  isLoading: boolean;
  refetch: () => void;
};
export function useClaimedStatusByCampaign(): UseClaimedStatusByCampaignReturn {
  const { address } = useAccount();
  const { data, isLoading, refetch } = useReadContract({
    address: getClaimerContractAddress(),
    abi: [
      {
        inputs: [
          {
            internalType: 'address',
            name: '_liquidityProvider',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: '_begin',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: '_end',
            type: 'uint256',
          },
        ],
        name: 'claimStatus',
        outputs: [
          {
            internalType: 'bool[]',
            name: '',
            type: 'bool[]',
          },
        ],
        stateMutability: 'view',
        type: 'function',
      },
    ],
    functionName: 'claimStatus',
    chainId: 8453,
    args: address ? [address, 0n, BigInt(MAX_WEEK_ON_CLAIMER)] : undefined,
  });

  const withWeeksMapped = useMemo(() => {
    const result = {} as ClaimedStatusByCampaign;
    if (data) {
      data.forEach((claimed, week) => {
        const campaign = getCampaignByWeek(week);
        if (!campaign) return;
        result[campaign.root.week_to_campaign_mapping.code] = claimed;
      });
    }
    return result;
  }, [data]);

  console.log('useClaimedStatusByCampaign claimedByCampaign:', withWeeksMapped, data);
  return {
    claimedByCampaign: withWeeksMapped,
    isLoading,
    refetch,
  };
}
